import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiButtonModule } from 'omnium-ui/button';

@Component({
    selector: 'app-enveloppe-change-confirmation-dialog',
    imports: [OuiDialogModule, OuiIconModule, OuiButtonModule],
    templateUrl: './enveloppe-change-confirmation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./enveloppe-change-confirmation-dialog.component.scss']
})
export class EnveloppeChangeConfirmationDialogComponent {
  constructor() {}

  @Output() confirm = new EventEmitter();

  confirmChange() {
    this.confirm.emit();
  }
}
